/* Niclas + ChatGPT | 2026-10-02 | AVOLT global locale-redirect */
(function() {
  var path = window.location.pathname;

  if (path === '/sv' || path === '/sv/') {
    window.location.replace('/sv-se');
    return;
  }

  if (path.indexOf('/sv/') === 0) {
    var newPath = '/sv-se/' + path.substring(4);
    window.location.replace(newPath + window.location.search + window.location.hash);
  }
})();
